enum CRC {
    "B",
    "A",
    "K",
    "P",
    "L",
    "C",
    "Q",
    "D",
    "R",
    "E",
    "V",
    "O",
    "S",
    "F",
    "T",
    "G",
    "U",
    "H",
    "M",
    "I",
    "N",
    "J",
    "W",
    "Z",
    "Y",
    "X",
}

export default CRC;
